// src/components/Navbar/Navbar.js
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Navigation.css';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <nav className="navbar-container">
      <NavLink to="/" className="navbar-logo" onClick={() => setIsMobileMenuOpen(false)}>
        <span className="navbar-name">Srihari</span>
      </NavLink>

      {/* Hire Me button for mobile view */}
      <NavLink to="/contact"><button className="navbar-hire-me navbar-hire-me-mobile">Hire Me</button></NavLink>

      <div
        className="navbar-mobile-toggle"
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        <span className={`navbar-hamburger ${isMobileMenuOpen ? 'open' : ''}`}></span>
      </div>

      <div className={`navbar-menu ${isMobileMenuOpen ? 'navbar-menu-mobile-active' : ''}`}>
        <ul className="navbar-links">
          <li>
            <NavLink
              to="/email-templates"
              className={({ isActive }) => (isActive ? 'navbar-link navbar-active' : 'navbar-link')}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Email Templates
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/websites"
              className={({ isActive }) => (isActive ? 'navbar-link navbar-active' : 'navbar-link')}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Websites
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/services"
              className={({ isActive }) => (isActive ? 'navbar-link navbar-active' : 'navbar-link')}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Services
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/test-code"
              className={({ isActive }) => (isActive ? 'navbar-link navbar-active' : 'navbar-link')}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Test Code
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contact"
              className={({ isActive }) => (isActive ? 'navbar-link navbar-active' : 'navbar-link')}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Contact
            </NavLink>
          </li>
        </ul>
      </div>

      {/* Hire Me button for desktop view, outside navbar-menu */}
      <NavLink to="/contact"><button className="navbar-hire-me navbar-hire-me-desktop">Hire Me</button></NavLink>
    </nav>
  );
};

export default Navbar;